export class CompanyDTO {
  public id!: string;
  public partnerId!: string;
  public cui!: string;
  public name!: string;
  public email!: string;
  public phone!: string;
}
